/**
 * Shared API route paths — the one place a path is written down.
 *
 * BUG-103 (AC4): the frontend posted `/ai/orchestrator` while the API mounted
 * `/ai/orchestrate`. Every unified-chat message 404'd, and nothing surfaced it:
 * `apiClient` throws on a 404 and `useUnifiedConversation` catches and falls
 * back to local processing, so the UI kept answering correctly off the
 * deterministic seeded path while its backend call was dead.
 *
 * Two independent string literals cannot be kept in sync by code review. The
 * frontend now imports this value instead of spelling it out, and
 * `src/test/BUG-103-route-parity.test.ts` asserts the API actually mounts this
 * exact path — so the two sides cannot drift again without a test failing.
 *
 * `/ai/orchestrate` is the name that wins: it is what `api/src/index.ts` and
 * `api/src/app.ts` mount and what `api/src/lib/openapi.ts` publishes. The
 * frontend literal was the lone outlier.
 *
 * Paths here are relative to the API's `/api` base path, which `apiClient`
 * prepends (`src/lib/api-client.ts`) and Hono applies via `.basePath('/api')`.
 */

/** Mounted by the API at `app.route(...)`; called by the frontend via `apiClient`. */
export const AI_ORCHESTRATOR_PATH = '/ai/orchestrate';
